import Avatar from "@/ui/avatar";

export const Token = ({
  imageUrl,
  symbol,
  name,
}: {
  imageUrl?: string;
  symbol: string;
  name: string;
}) => {
  return (
    <div className="flex-row flex gap-1.5 items-center text-xs ml-[0.3125rem]">
      {imageUrl && <Avatar size="bigger" source={imageUrl} />}
      <p className="font-normal text-[#8F8D92] capitalize">
        <b className="text-white font-semibold">{symbol}</b>&nbsp;
        {name.length > 25 ? `${name.slice(0, 23)}...` : name}
      </p>
    </div>
  );
};
